// Day.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { DayContainer, DayWrapper, Side } from './style';

function Day({
  backgroundColor,
  children,
  disabled = false,
  hidden = false,
  leftSideColor,
  rightSideColor,
  textColor,
  disablePointer = false,
  type = 'button',
  // internal props we don't want on DOM:
  isAnimating,
  onDaySelect,
  disableHighlightToday,
  today,
  outsideCurrentMonth,
  isFirstVisibleCell,
  isLastVisibleCell,
  day,
  ...rest
}) {
  // Only pass safe props to DOM
  const safeProps = { ...rest };

  return (
    <DayWrapper role="presentation">
      <Side $backgroundColor={disabled ? 'transparent' : leftSideColor} />
      <DayContainer
        $backgroundColor={backgroundColor}
        disabled={disabled}
        tabIndex={hidden || disabled ? -1 : 0}
        $textColor={textColor}
        $disablePointer={disablePointer}
        type={type}
        {...safeProps}
      >
        {!hidden && <span>{children}</span>}
      </DayContainer>
      <Side $backgroundColor={disabled ? 'transparent' : rightSideColor} />
    </DayWrapper>
  );
}

Day.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.object]),
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  leftSideColor: PropTypes.string,
  rightSideColor: PropTypes.string,
  textColor: PropTypes.string,
  type: PropTypes.string,
  disablePointer: PropTypes.bool,
  isAnimating: PropTypes.bool,
  onDaySelect: PropTypes.func
};

export default Day;
